import React from 'react';
import ImageMockup from './ImageMockup';
import ArrowDown from '../../asset/ArrowDown'

// image grid uses image tags
// first -- url for image
// style -- for color theme
const ImageGridFront = ({first, title, themeColor}) => (
  <section>
    <div className="grid" style={{backgroundColor: themeColor,}}>
      <div className="container">
        <div className="wrap">
          <div className="col col-1">
            <h1 className="slogan extra-padding-top nav-top-offset" style={{
                color: 'white',
                textAlign: 'center',
              }}>
              {title}
            </h1>
            <ImageMockup image={first}/>
          </div>
          <div className="arrowAnimation">
             <ArrowDown/>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ImageGridFront;



// WEBPACK FOOTER //
// ./src/layout/portfolio/ImageGridFront.js